import { useEffect, useState } from 'react';

import { useTogglDataContext } from '../../../../screens/TogglDataProvider';
import { ImportMappings } from '../../../../types';
import { TogglTimeEntry } from '../../../../types/toggl-api';
import { extractIssueKeyFromTimeEntry } from '../../../../utils/utils';

export function useTableIssueKeys(
  mappings: ImportMappings,
  timeEntries: TogglTimeEntry[]
) {
  const { projects, tags, tasks } = useTogglDataContext();
  const [issueKeys, setIssueKeys] = useState<{ [timeEntryId: number]: string }>(
    {}
  );
  const [detectedIssueKeys, setDetectedIssueKeys] = useState<{
    [timeEntryId: number]: string;
  }>({});

  useEffect(() => {
    const extractedIssueKeys = timeEntries.reduce(
      (acc: { [timeEntryId: string]: string }, timeEntry) => {
        if (issueKeys[timeEntry.id]) {
          acc[timeEntry.id] = issueKeys[timeEntry.id];
          return acc;
        }

        const mappedJiraIssueKey = mappings?.[timeEntry.id]?.jiraIssueKey;
        if (mappedJiraIssueKey) {
          acc[timeEntry.id] = mappedJiraIssueKey;
          return acc;
        }

        const issueKey = extractIssueKeyFromTimeEntry(timeEntry, {
          projects,
          tasks,
          tags,
        });
        if (issueKey) {
          acc[timeEntry.id] = issueKey;
        }
        return acc;
      },
      {}
    );
    setIssueKeys(extractedIssueKeys);
    setDetectedIssueKeys(extractedIssueKeys);
  }, [timeEntries, mappings]);

  const setIssueKey = (timeEntryId: number, issueKey: string) => {
    setIssueKeys((prev) => ({ ...prev, [timeEntryId]: issueKey }));
  };

  return { issueKeys, setIssueKey, detectedIssueKeys };
}
